module.exports = __webpack_public_path__ + "static/media/Balance-r-female.1d679fcd.svg";